import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isEditPersonalWeeklyCalendarRequestFailure() {
      return getState().isFailure;
    },
    isEditPersonalWeeklyCalendarRequestPending() {
      return getState().isPending;
    },
    isEditPersonalWeeklyCalendarRequestSuccess() {
      return getState().isSuccessful;
    },
  };
}

export { createSelector };
